/**
 * External dependencies
 */
import { map, get } from "lodash";

/**
 * Internal dependencies
 */
import getDashboardLayout from "./get-dashboard-layout";
import { getReport } from "state/reports/selectors";

//import { getEditorWidgetId } from 'state/ui/widget-editor/selectors';

export default (state) => {
  const layout = getDashboardLayout(state) || {};
  //let editedId =  getEditorWidgetId(state);
  return map(layout.items, ({ id, position, widgetId: reportId }) => {
    let report = getReport(state, reportId);
    let template = get(report, "template", "custom");

    return {
      id,
      reportId,
      includeEdits: false,
      template,
      report,
      position,
    };
  });
};
